/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TranslatorWidget_exercise = {
    readonly content: {
        readonly prompt: string;
        readonly correctAnswers: ReadonlyArray<string>;
        readonly scrambledParts: ReadonlyArray<string>;
    };
    readonly " $refType": "TranslatorWidget_exercise";
};
export type TranslatorWidget_exercise$data = TranslatorWidget_exercise;
export type TranslatorWidget_exercise$key = {
    readonly " $data"?: TranslatorWidget_exercise$data;
    readonly " $fragmentRefs": FragmentRefs<"TranslatorWidget_exercise">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "TranslatorWidget_exercise",
  "type": "TranslationExercise",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "content",
      "storageKey": null,
      "args": null,
      "concreteType": "TranslationExerciseContent",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "prompt",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "correctAnswers",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "scrambledParts",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'af31dd3fd30b9f359d7b554be5bd33cc';
export default node;
